
<script>
import { useRouter,useRoute } from "vue-router";
//model
import { AddCartModel } from '@/core/Cart/model/CartModel';
import Topup2c2pService from "../../service/Topup2c2pService";
import BzbsAuth from "@/core/Account/service/BzbsAuth"
//feature
import { useLandingFlow } from '../../feature/LandingFlowFeature'
import { CampaignType } from '@/helper/StaticValue'

export default {
    name: "CampaignItem",
    props: {
        campaign: { type: Object, required: true },
    },
    setup(props){
        // const { lbl , localeCode } = useLocale()
        const router = useRouter()
        const route = useRoute()
        const { query, blobWebLanding } = useLandingFlow()

        const getPrice = () => {
            return props.campaign.pricePerUnit
        }

        const clickCampaign = async () => {
            if (props.campaign.type == CampaignType.Pinless) {
                router.replace('/topup2c2p/detail/' + route.params.categoryId + '/' + props.campaign.id)
            } else {
                await addToCart(props.campaign.id)
                goShoppingCartProduct()
            }

        }


        const addToCart = (campaignId) => {
            return new Promise((resolve) => {
                var cartItem = new AddCartModel();
                cartItem.addItem(campaignId, 1)
                cartItem.setClearCart()
                var cartParams = cartItem.getParamsItem();
                var list = cartItem.getList();
                Topup2c2pService.apiAddItemToCart(query.value.token, cartParams, query.value.appId, list, blobWebLanding.value, query.value.jwt).subscribe({
                    next: (data) => {
                        console.log(data)
                        resolve();
                    },
                    error: (err) => {
                        console.log(err)
                        resolve();
                        // errorApi(err);
                    },
                });
            });
        }


        const goShoppingCartProduct = async () => {
            let accessKey = await getShoppingCartAccessKey()

            if (accessKey == null) {
                return
            }

            let appName = query.value.appName
            let url = query.value.shoppingCartUrl+ `/landing/${appName}/shipping?access_key=${accessKey}&appname_config=${appName}`
            // let url = query.value.shoppingCartUrl+ `/${appName}?access_key=${accessKey}&appname_config=${appName}`
            window.location.href = url
        }

        const getShoppingCartAccessKey = () => {
            return new Promise((resolve) => {
                let payload = {
                    returnUrl: query.value.returnUrl,
                    successUrl: query.value.returnUrl,
                    errorUrl: query.value.returnUrl,
                    appId: query.value.appId,
                    appName: query.value.appName,
                    cartType: 'C2PTopup',
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(query.value.token, jsonPayload).subscribe({
                    next: (data) => {
                        resolve(data.accessKey)
                    },
                    error: (err) => {
                        console.log(err)
                        resolve(null)
                        //errorApi(err)
                    },
                })
            });
        }
        return {
            getPrice,
            clickCampaign
        }
    },
}
</script>
<template>
    <div class="border overflow-hidden cursor-pointer rounded-lg" @click="clickCampaign()">
        <div class="campaign-image" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
        <div class="px-2 pt-1 pb-2">
            <div class="font-14 text-a-gray-4a4a4a text-center campaign-name">{{campaign.name}}</div>
            <div class="bg-a-orange-f9a601 rounded-lg text-white text-center py-1.5">฿ {{FilterNumberFormat(getPrice())}}</div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    @import "@/style/base/text.scss";
    .campaign-image {
        @include boxRatio($ratio: 100%);
    }

    .campaign-name {
        @extend %ellipsis-2;
        height: 50px;
    }
</style>
